
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M17.99 37.328c-3.69-.067-7.068-.053-9.146.31-2.689.468-1.59 1.563 0 1.862.365.069.819.103 1.244.136 1.166.09 2.116.163.412.864-6.762 2.78 8.192 3.85 17.5 1.888 2.979-.628 5.3-.425 7.69-.216 1.22.107 2.458.216 3.81.216 5 0 8.657-1.322 5-2.888-.725-.31-1.95-.595-3.441-.845l1.2-27.54A2 2 0 0 0 40.264 9l-21.556 3a2 2 0 0 0-1.996 2.13z"}}),_c('path',{staticClass:"i-Line 129",attrs:{"stroke":"#234652","d":"M29 25.5h7"}}),_c('path',{staticClass:"i-Line 130",attrs:{"stroke":"#234652","d":"M29 13.5h7"}}),_c('path',{staticClass:"i-Line 131",attrs:{"stroke":"#234652","d":"M33 29.5h3"}}),_c('path',{staticClass:"i-Line 132",attrs:{"stroke":"#234652","d":"M33 17.5h3"}}),_c('path',{staticClass:"i-Line 133",attrs:{"stroke":"#234652","d":"M33 33.5h3"}}),_c('path',{staticClass:"i-Line 134",attrs:{"stroke":"#234652","d":"M33 21.5h3"}}),_c('path',{staticClass:"i-beaker",attrs:{"stroke":"#234652","d":"M42.287 7.845c-.952 2.335-2.016 5.225-2.282 7.084-.216 1.509-.427 6.128-.6 10.923-.173 4.813-.309 9.85-.37 12.231-.016.634-.423 1.133-.993 1.236C36.459 39.606 33.32 40 28 40c-5.564 0-9.181-.43-10.994-.722-.609-.098-1.063-.612-1.108-1.262l-1.6-23.096a1.977 1.977 0 0 0-3.9-.304L7.485 27.33c-.414 1.81-3.098 1.402-2.957-.449l1.33-17.474c.06-.79.72-1.4 1.515-1.398 5.191.01 20.017-.095 28.214-1.517 1.777-.309 3.395-.641 4.756-.945 1.283-.286 2.44 1.082 1.945 2.297Z"}})])
          )
        }
      }
    